import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'motion/react';
import PageNavbar from './PageNavbar';
import Footer from './Footer';
import ScrollReveal from './ScrollReveal';
import { getRevealProps, staggerContainer, staggerItem, defaultViewport } from '../motion/scrollMotion';
import './ContentPages.css';

const guides = [
  {
    tag: 'Compliance',
    title: 'The ISO 27001 Readiness Roadmap',
    desc: 'A step-by-step path from gap analysis through Stage 1 and Stage 2 certification audits — what to build first, and what auditors actually check.',
  },
  {
    tag: 'Compliance',
    title: 'PCI DSS Scope Reduction Playbook',
    desc: 'How tokenization, network segmentation, and outsourced payment pages reduce how much of your environment falls under PCI DSS scope.',
  },
  {
    tag: 'Managed IT',
    title: 'CIS Benchmark Hardening Playbook',
    desc: 'A practical, benchmark-based approach to hardening servers and endpoints without breaking the applications that run on them.',
  },
  {
    tag: 'Incident Response',
    title: 'Building an Incident Response Plan That Survives Contact',
    desc: 'Why most IR plans fail during a real incident, and how to structure roles, runbooks, and communication so yours does not.',
  },
  {
    tag: 'Cloud Security',
    title: 'Multi-Cloud Security Baseline Checklist',
    desc: 'A working checklist for AWS, Azure, and GCP covering IAM, storage, logging, and network exposure — the same one our assessors use.',
  },
  {
    tag: 'Cybersecurity',
    title: 'Choosing Between Managed and Co-Managed Security',
    desc: 'A framework for deciding how much of your security operations to outsource versus keep in-house, based on team size and risk tolerance.',
  },
];

const SolutionGuidesPage = () => (
  <div className="content-page">
    <PageNavbar />

    <section className="content-hero">
      <div className="content-hero-background" />
      <div className="content-hero-stars" />
      <ScrollReveal className="content-hero-inner" animateOnMount variant="fadeUp">
        <span className="content-badge">Solution Guides</span>
        <h1 className="content-hero-title">
          Practical Guides, <span className="content-accent">Not Sales Sheets.</span>
        </h1>
        <p className="content-hero-desc">
          Step-by-step guides to the compliance and security challenges we help clients solve most
          often — written to be useful whether or not you ever become a client.
        </p>
      </ScrollReveal>
    </section>

    <section className="content-section alt">
      <div className="content-container">
        <motion.div className="content-section-header" {...getRevealProps('fadeUp')}>
          <span className="content-section-tag">Guide Library</span>
          <h2 className="content-section-title">Solving Common Security & Compliance Challenges</h2>
          <p className="content-section-subtitle">
            Request any guide below and a member of our team will walk you through it directly —
            we would rather talk it through than send a PDF into a void.
          </p>
        </motion.div>

        <motion.div
          className="content-grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
        >
          {guides.map((g) => (
            <motion.div key={g.title} className="content-card" variants={staggerItem}>
              <div className="content-meta">{g.tag}</div>
              <h3 className="content-card-title">{g.title}</h3>
              <p className="content-card-desc">{g.desc}</p>
              <Link to="/contact" className="content-card-link blog-read-btn">
                Request This Guide <FaArrowRight />
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>

    <Footer />
  </div>
);

export default SolutionGuidesPage;
